import type {
  CartStoreType, ReceivingMethods, ShippingGroupType, ThirdPartyStoreType,
} from '@common/contracts/server/ostin/api';
import IconDelivery from '@icons/box.svg';
import IconStore from '@icons/club.svg';
import IconExpressDelivery from '@icons/express-delivery.svg';
import IconPickup from '@icons/point.svg';
import IconPostamat from '@icons/postamat.svg';
import IconPostOffice from '@icons/postoffice.svg';
import IconPVZ from '@icons/pvz.svg';

export type TShippingGroupType = typeof ShippingGroupType;

// Типы шиппинг групп в корзине
export const SHIPPING_GROUP_NAMES: TShippingGroupType = {
  unallocated: 'unallocated',
  soldout: 'soldout',
  delivery: 'delivery',
  thirdparty: 'thirdparty',
  pickup: 'pickup',
  express_delivery: 'express_delivery',
} as const;

export type TReceivingMethods = typeof ReceivingMethods;

// Способы получения для заказов
export const SHIPPING_METHODS: TReceivingMethods = {
  delivery: 'delivery',
  pickup: 'pickup',
  thirdparty: 'thirdparty',
  post: 'post',
  gift_card: 'gift_card',
} as const;

export type TCartStoreType = typeof CartStoreType;

export const CART_STORE_TYPE: TCartStoreType = {
  store: 'store',
  pvz: 'pvz',
  postamat: 'postamat',
  post: 'post',
} as const;

export type TThirdPartyStoreType = typeof ThirdPartyStoreType;

export const THIRD_PARTY_STORE_TYPE: TThirdPartyStoreType = {
  pvz: 'pvz',
  postamat: 'postamat',
  post: 'post',
} as const;

/**
 * @deprecated - использовать подходящие константы из delivery.ts
 */
export const DELIVERY_TYPES = {
  // TODO: Используется только в GTM, возможно стоит удалить
  availability: 'availability',
  pickup: SHIPPING_METHODS.pickup,
  delivery: SHIPPING_METHODS.delivery,
  postamat: CART_STORE_TYPE.postamat,
  store: CART_STORE_TYPE.store,
  post: SHIPPING_METHODS.post,
  thirdparty: SHIPPING_METHODS.thirdparty,
  express: SHIPPING_GROUP_NAMES.express_delivery,
} as const;

export const RECEIVING_METHOD_ICONS: Record<string, string> = {
  [SHIPPING_METHODS.delivery]: IconDelivery,
  [SHIPPING_GROUP_NAMES.express_delivery]: IconExpressDelivery,
  [SHIPPING_METHODS.pickup]: IconPickup,
  [CART_STORE_TYPE.store]: IconStore,
  [CART_STORE_TYPE.post]: IconPostOffice,
  [CART_STORE_TYPE.pvz]: IconPVZ,
  [CART_STORE_TYPE.postamat]: IconPostamat,
};

export const NOTIFICATIONS_EXPRESS_DELIVERY = 'expressDelivery';

export const NOTIFICATIONS_ORDER_RECEIVING_METHOD: Record<string, string> = {
  [SHIPPING_METHODS.delivery]: '',
  [NOTIFICATIONS_EXPRESS_DELIVERY]: 'Экспресс-доставка',
  [SHIPPING_METHODS.pickup]: 'Самовывоз',
  [CART_STORE_TYPE.store]: 'Магазин FUNDAY',
  [CART_STORE_TYPE.post]: 'Отделение Почты России',
  [CART_STORE_TYPE.pvz]: 'ПВЗ',
  [CART_STORE_TYPE.postamat]: 'Постамат',
};

export const NOTIFICATIONS_ORDER_ICONS = {
  [SHIPPING_METHODS.delivery]: IconDelivery,
  [NOTIFICATIONS_EXPRESS_DELIVERY]: IconExpressDelivery,
  [SHIPPING_METHODS.pickup]: IconPickup,
  [CART_STORE_TYPE.store]: IconStore,
  [CART_STORE_TYPE.post]: IconPostOffice,
  [CART_STORE_TYPE.pvz]: IconPVZ,
  [CART_STORE_TYPE.postamat]: IconPostamat,
};
